export interface ServerConfig {
  port: number;
};
export interface DatabaseConfig {
  type: 'postgres';
  host: string;
  port: number;
  database: string;
  username: string;
  password: string;
  entities: string[];
  synchronize: false;
  logging: boolean;
};
export interface ExternalConfig {
  leadOrigin: string;
  couponBucketName: string;
  awsProfile?: string;
  slackWebhookUrl: string;
  sendgridApikey: string;
};
export interface MailConfig {
  envName: string;
  emailBodyHeader: string;
  emailBcc: string;
}
export interface Config {
  env: string;
  server: ServerConfig;
  database: DatabaseConfig;
  externals: ExternalConfig;
  mail: MailConfig;
}
export const config = (): Config => ({
  env: process.env.NODE_ENV || 'development',
  server: {
    port: parseInt(process.env.PORT || '3000', 10),
  },
  database: {
    type: 'postgres',
    host: process.env.DATABASE_HOST!,
    port: parseInt(process.env.DATABASE_PORT!, 10),
    database: process.env.DATABASE_NAME!,
    username: process.env.DATABASE_USERNAME!,
    password: process.env.DATABASE_PASSWORD!,
    entities: [__dirname + '/../**/*.entity{.ts,.js}'],
    synchronize: false,
    logging: true,
  },
  externals: {
    leadOrigin: process.env.LEAD_ORIGIN!,
    couponBucketName: process.env.COUPON_BUCKET_NAME!,
    awsProfile: process.env.AWS_PROFILE,
    slackWebhookUrl: process.env.SLACK_WEBHOOK_URL!,
    sendgridApikey: process.env.SENDGRID_API_KEY!,
  },
  mail: {
    envName: process.env.ENV_NAME!,
    emailBodyHeader: process.env.EMAIL_BODY_HEADER || '',
    emailBcc: process.env.EMAIL_BCC!,
  },
});
